/*
 * @Author: 黄智强
 * @Date: 2018-01-27 10:00:27
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-02-06 17:23:56
 * @说明：文件删除接口地址
 */
// 文件删除
export const fileDelete = '/upload/delete'



// WEBPACK FOOTER //
// ./src/api/url/fileUpload.js